
import { useState } from 'react';

export const QuoteForm = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [messageLength, setMessageLength] = useState(0);
  const [showSuccess, setShowSuccess] = useState(false);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsSubmitting(true);

    const formData = new FormData(e.currentTarget);
    
    try {
      const response = await fetch('https://readdy.ai/api/form/d49qgi0lr2seorfomkbg', {
        method: 'POST',
        body: new URLSearchParams(formData as any),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      });

      if (response.ok) {
        setShowSuccess(true);
        (e.target as HTMLFormElement).reset();
        setMessageLength(0);
      } else {
        alert('Bir hata oluştu. Lütfen tekrar deneyin.');
      }
    } catch (error) {
      alert('Bir hata oluştu. Lütfen tekrar deneyin.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleMessageChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setMessageLength(e.target.value.length);
  };

  if (showSuccess) {
    return (
      <div className="bg-white rounded-2xl shadow-xl p-8">
        <div className="text-center">
          <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <i className="ri-check-line text-2xl text-green-600"></i>
          </div>
          <h3 className="text-2xl font-bold text-gray-900 mb-2">Talebiniz Alındı!</h3>
          <p className="text-gray-600 mb-6">Uzmanımız en kısa sürede sizi arayacaktır.</p>
          <button
            onClick={() => setShowSuccess(false)}
            className="bg-blue-600 text-white py-2 px-6 rounded-lg hover:bg-blue-700 transition-colors whitespace-nowrap cursor-pointer"
          >
            Yeni Teklif Al
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-2xl shadow-xl p-8">
      <div className="text-center mb-8">
        <h2 className="text-3xl font-bold text-gray-900 mb-4">Ücretsiz Teklif Alın</h2>
        <p className="text-gray-600">İhtiyaçlarınızı belirtin, size özel çözümler sunalım</p>
      </div>

      <form 
        id="quote-form"
        data-readdy-form
        onSubmit={handleSubmit}
        className="space-y-6"
      >
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <label htmlFor="adSoyad" className="block text-sm font-medium text-gray-700 mb-2">
              Ad Soyad *
            </label>
            <input
              type="text"
              id="adSoyad"
              name="adSoyad"
              required
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
              placeholder="Adınız ve soyadınız"
            />
          </div>

          <div>
            <label htmlFor="telefon" className="block text-sm font-medium text-gray-700 mb-2">
              Telefon *
            </label>
            <input
              type="tel"
              id="telefon"
              name="telefon"
              required
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
              placeholder="0532 123 45 67"
            />
          </div>

          <div className="md:col-span-2">
            <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
              E-posta *
            </label>
            <input
              type="email"
              id="email"
              name="email"
              required
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
              placeholder="ornek@email.com"
            />
          </div>

          <div>
            <label htmlFor="calisanSayisi" className="block text-sm font-medium text-gray-700 mb-2">
              Çalışan Sayısı *
            </label>
            <input
              type="number"
              id="calisanSayisi"
              name="calisanSayisi"
              required
              min="1"
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
              placeholder="Örn: 25"
            />
          </div>

          <div>
            <label htmlFor="tehlikeSinifi" className="block text-sm font-medium text-gray-700 mb-2">
              Tehlike Sınıfı *
            </label>
            <div className="relative">
              <select
                id="tehlikeSinifi"
                name="tehlikeSinifi"
                required
                className="w-full px-4 py-3 pr-8 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm appearance-none cursor-pointer"
              >
                <option value="">Seçiniz</option>
                <option value="Az Tehlikeli">Az Tehlikeli</option>
                <option value="Tehlikeli">Tehlikeli</option>
                <option value="Çok Tehlikeli">Çok Tehlikeli</option>
              </select>
              <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                <i className="ri-arrow-down-s-line text-gray-400"></i>
              </div>
            </div>
          </div>

          <div className="md:col-span-2">
            <label htmlFor="mesaj" className="block text-sm font-medium text-gray-700 mb-2">
              Mesaj
            </label>
            <textarea
              id="mesaj"
              name="mesaj"
              rows={4}
              maxLength={500}
              onChange={handleMessageChange}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm resize-none"
              placeholder="İhtiyaçlarınız hakkında detaylı bilgi verebilirsiniz..."
            />
            <div className="text-right text-sm text-gray-500 mt-1">
              {messageLength}/500
            </div>
          </div>
        </div>

        <button
          type="submit"
          disabled={isSubmitting}
          className="w-full bg-blue-600 text-white py-4 px-6 rounded-lg hover:bg-blue-700 transition-colors font-semibold mt-6 disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap cursor-pointer"
        >
          {isSubmitting ? 'Gönderiliyor...' : 'Gönder'}
        </button>
      </form>
    </div>
  );
};
